import { Injectable } from '@angular/core';

export enum FileMimeType {
  JSON = 'application/json',
  CSV = 'text/csv',
  TEXT = 'text/plain',
  KMZ = 'application/vnd.google-earth.kmz',
  KML = 'application/vnd.google-earth.kml+xml',
}

@Injectable({
  providedIn: 'root',
})
export class FileService {
  // downloadFile(
  //   content: string | Blob,
  //   fileName: string,
  //   fileType: FileMimeType = FileMimeType.TEXT,
  // ): void {
  //   const blob = content instanceof Blob ? content : new Blob([content], { type: fileType });
  //   const url = window.URL.createObjectURL(blob);
  //   const a = document.createElement('a');
  //   a.href = url;
  //   a.download = fileName;
  //   document.body.appendChild(a);
  //   a.click();
  //   document.body.removeChild(a);
  //   window.URL.revokeObjectURL(url);
  // }

  downloadFile(blob: Blob, fileName: string, fileFormat: string) {
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = `${fileName}.${fileFormat}`;
    a.style.display = 'none';
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
    // ссылку освобождаем не сразу: iOS Safari и WebView начинают скачивание асинхронно,
    // и отозванный сразу после click() URL даёт пустую загрузку или не открывается
    setTimeout(() => window.URL.revokeObjectURL(url), 40000);
  }

  extractFileNameAndFormat(
    contentDisposition: string | null,
    defaultName = 'default_name',
    defaultFormat = 'alp',
  ): {
    fileName: string;
    fileFormat: string;
  } {
    let fileName = defaultName;
    let fileFormat = defaultFormat;

    if (contentDisposition) {
      const fileNameMatch = contentDisposition.match(/filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/);

      if (fileNameMatch?.[1]) {
        const rawFileName = fileNameMatch[1].replace(/['"]/g, '');

        const decodedFileName = decodeURIComponent(rawFileName);

        const parts = decodedFileName.split('.');
        if (parts.length > 1) {
          fileFormat = parts.pop() || defaultFormat;
          fileName = parts.join('.');
        } else {
          fileName = decodedFileName;
        }
      }
    }

    return { fileName, fileFormat };
  }

  // extractFileNameAndFormat(contentDisposition: string | null): {
  //   fileName: string;
  //   fileFormat: string;
  // } {
  //   let fileName = 'default_name';
  //   let fileFormat = 'txt';
  //
  //   if (contentDisposition) {
  //     const fileNameMatch = contentDisposition.match(/filename="(.+?)"/);
  //     if (fileNameMatch?.[1]) {
  //       fileName = fileNameMatch[1].split('.').slice(0, -1).join('.');
  //       fileFormat = fileNameMatch[1].split('.').pop() || 'txt';
  //     }
  //   }
  //
  //   return { fileName, fileFormat };
  // }
}
